import api from './api';

export const getItems = (currentPage, PageSize, config) => {
    let errors = [];
    if (!currentPage) {
        errors.push('current page');
    }
    if (!PageSize) {
        errors.push('page size');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`${process.env.REACT_APP_URL}/Item/GetItems?PageNumber=${currentPage}&PageSize=${PageSize}`, config);
    }
}

export const fetchItem = (itemConfig) => {
    let errors = [];
    if (!itemConfig) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return fetch(`${process.env.REACT_APP_URL}/Item/FetchItems`, {
            method: 'POST',
            ...itemConfig,
            body: ""
        })
    }
}
